import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isOpen: false,
  isAiBuilder: false,
};

const createWheelPopupSlice = createSlice({
  name: 'createWheelPopup',
  initialState,
  reducers: {
    showCreateWheelPopup(state) {
      state.isOpen = true;
    },
    hideCreateWheelPopup(state) {
      state.isOpen = false;
    },
    toggleCreateWheelPopup(state) {
      state.isOpen = !state.isOpen;
    },
  },
});

export const { showCreateWheelPopup, hideCreateWheelPopup, toggleCreateWheelPopup } =
  createWheelPopupSlice.actions;

export default createWheelPopupSlice.reducer;
